import _objectSpread from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import { Primitive as e } from "@radix-ui/react-primitive";
import * as r from "react";
import t from "@babel/runtime/helpers/esm/extends";
export var VisuallyHidden = /*#__PURE__*/r.forwardRef(function (i, o) {
  return /*#__PURE__*/r.createElement(e.span, t({}, i, {
    ref: o,
    style: _objectSpread(_objectSpread({}, i.style), {}, {
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal"
    })
  }));
}); /*#__PURE__*/
export var Root = VisuallyHidden;